"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
/* eslint-disable */
var Tick = function Tick(props) {
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], _extends({
    viewBox: "0 0 26 20"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-948.000000, -752.000000)",
    fillRule: "nonzero",
    fill: "#989BA4"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(395.000000, 214.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(553.000000, 464.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0.3,85 C0.1,84.8 0,84.5 0,84.3 C0,84.1 0.1,83.8 0.3,83.6 L1.7,82.2 C2.1,81.8 2.7,81.8 3.1,82.2 L3.2,82.3 L8.7,88.2 C8.9,88.4 9.2,88.4 9.4,88.2 L22.8,74.3 L22.9,74.3 L22.9,74.3 C23.3,73.9 23.9,73.9 24.3,74.3 L25.7,75.7 C26.1,76.1 26.1,76.7 25.7,77.1 L25.7,77.1 L9.7,93.7 C9.5,93.9 9.3,94 9,94 C8.7,94 8.5,93.9 8.3,93.7 L0.5,85.3 L0.3,85 Z"
  })))));
};
/* eslint-enable */
var _default = Tick;
exports["default"] = _default;